import { Routes } from '@angular/router';


export const routes: Routes = [
    { path: 'int', loadChildren: () => import('../asbestos/internal/asbestos.module').then(m => m.AsbestosInternalModule)},
    { path: 'ext', loadChildren: () => import('../asbestos/external/asbestos.module').then(m => m.AsbestosExternalModule)}
];
